const config = {
  intercomKey: process.env.RUN_ENV === 'production'
      ?'xhg3rkvm'
      : process.env.RUN_ENV === 'staging'
      ?'xhg3rkvm'
      :'gg89dowv',
  hotjarKey: process.env.RUN_ENV === 'production' ? '1511776' : null,
  pluginsHost:
    process.env.RUN_ENV === 'production'
      ? 'https://getnave.com'
      : process.env.RUN_ENV === 'staging'
      ? 'https://naveapp.com'
      : 'https://nave.be'
};

export default config;
